"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isStaticComparison(spec) {
    return spec.type === 'STATIC_COMPARISON';
}
exports.isStaticComparison = isStaticComparison;
function isMarkBasedComparison(spec) {
    return spec.type === 'MARK_BASED_COMPARISON';
}
exports.isMarkBasedComparison = isMarkBasedComparison;
exports.isNoComparison = function (spec) {
    return spec.type === 'NO_COMPARISON';
};
function isHistoricalComparisonSpec(spec) {
    return spec.type === 'HISTORICAL_COMPARISON';
}
exports.isHistoricalComparisonSpec = isHistoricalComparisonSpec;
//# sourceMappingURL=ComparisonSpecType.js.map